import { DateTime } from 'luxon';

import type { IIapPoll } from '~/lib/api/modules/IapPolls';

export type IIapPollStatus = 'ended' | 'programmed' | 'running' | 'inactive';

export type IIapPollInfo = {
  startAt?: DateTime;
  endAt?: DateTime;
  ended: boolean;
  started: boolean;
  running: boolean;
  programmedAt?: DateTime;
  status: IIapPollStatus;
};

export const getIapPollInfo = (iapPoll: IIapPoll): IIapPollInfo => {
  const startAt = iapPoll.startDate
    ? DateTime.fromISO(iapPoll.startDate)
    : undefined;
  const endAt = iapPoll.endDate ? DateTime.fromISO(iapPoll.endDate) : undefined;
  const ended = endAt ? endAt < DateTime.now() : false;
  const started = startAt ? startAt < DateTime.now() : true;
  const running = started && !ended;
  const programmedAt = !running && !ended ? startAt : undefined;
  const status: IIapPollStatus = ended
    ? 'ended'
    : iapPoll.active
      ? programmedAt
        ? 'programmed'
        : running
          ? 'running'
          : 'ended'
      : 'inactive';

  return {
    startAt,
    endAt,
    ended,
    started,
    running,
    programmedAt,
    status,
  };
};
